import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CurrencyPound = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 12C25.552 12 26 11.552 26 11V10C26 5.589 22.411 2 18 2C13.589 2 10 5.589 10 10C10 11.438 9.962 12.769 9.895 14H7C6.448 14 6 14.448 6 15C6 15.552 6.448 16 7 16H9.754C9.623 17.505 9.448 18.834 9.249 20H7.001C6.449 20 6.001 20.448 6.001 21C6.001 21.552 6.449 22 7.001 22H8.853C8.621 23.019 8.365 23.866 8.144 24.564C7.376 27 6.356 28.236 6.356 28.236C6.11 28.482 6.001 28.693 6.001 28.999C6.001 29.551 6.449 29.999 7.001 29.999C7.005 29.999 7.009 29.999 7.014 29.998C7.016 29.998 7.017 29.999 7.019 29.999H25.002C25.554 29.999 26.002 29.551 26.002 28.999C26.002 28.447 25.554 27.999 25.002 27.999H8.864C9.495 26.8 10.274 24.886 10.899 21.999H15.002C15.554 21.999 16.002 21.551 16.002 20.999C16.002 20.447 15.554 19.999 15.002 19.999H11.277C11.473 18.803 11.64 17.474 11.764 15.999H17.502C18.054 15.999 18.502 15.551 18.502 14.999C18.502 14.447 18.054 13.999 17.502 13.999H11.901C11.966 12.758 12.002 11.427 12.002 9.999C12.002 6.691 14.693 3.999 18.002 3.999C21.311 3.999 24.002 6.691 24.002 9.999V10.999C24.002 11.551 24.45 11.999 25.002 11.999L25 12Z" />
	</svg>
);

export default CurrencyPound;
